__turbopack_context__.v({
  "badge": "NotificationBell-module-scss-module__4ig7Ma__badge",
  "bellButton": "NotificationBell-module-scss-module__4ig7Ma__bellButton",
});
